import React, { useEffect, useGlobal } from 'reactn';
import { SidePanelStyled } from './sidePanelStyled';
import Icon from '../icons/ReturnIcons';

const SidePanel = ({ isOpen, onClose, children }) => {
    const [refetch, setRefetch] = useGlobal('refetch');
    const [successfullApiCall, setSuccessfullApiCall] = useGlobal("successfullApiCall");
    const handleClose = () => {
        if(successfullApiCall) { 
            setRefetch(!refetch);
        }
        onClose();
    }
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

   

    return (
        <SidePanelStyled>
            <>
                {isOpen && <div className="backDrop" onClick={handleClose}></div>}
                <div className={`modal ${isOpen ? 'open' : ''}`}>
                    <div className="modal-content">
                        <div onClick={handleClose} className='closeButton'><Icon src='xIcon' /> Close</div>
                        {children}

                    </div>
                </div>
            </>
        </SidePanelStyled>
    );
}

export default SidePanel;
